<template>
  <div class="min-h-screen md:px-4 mt-6 font-inter pb-10">
    <main class="w-full h-full">
      <SettingsComponent />
    </main>
  </div>
</template>

<script>
import SettingsComponent from "@/components/settings/SettingsComponent.vue";

export default {
  name: "SettingsView",
  components: {
    SettingsComponent,
  },
};
</script>

<style scoped>
/* Add any layout styles here */
</style>
